import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getMyAssignments, startAssignment, Assignment } from '../../services/api';

interface AssignmentCardProps {
  studentId: string;
}

export const AssignmentCard: React.FC<AssignmentCardProps> = ({ studentId }) => {
  const [assignments, setAssignments] = useState<Assignment[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMyAssignments(studentId)
      .then((data) => {
        // Show pending and in_progress
        setAssignments(data.filter((a) => a.status === 'pending' || a.status === 'in_progress'));
      })
      .catch(() => setAssignments([]))
      .finally(() => setLoading(false));
  }, [studentId]);

  if (loading || assignments.length === 0) return null;

  const handleStart = async (assignment: Assignment) => {
    if (assignment.status === 'pending') {
      try {
        await startAssignment(assignment.id, studentId);
      } catch (err) {
        console.error('Failed to start assignment:', err);
      }
    }
  };

  return (
    <div className="assignment-card">
      <h3>Assignments from Parent</h3>
      <div className="assignment-items">
        {assignments.map((a) => {
          const pct = a.num_questions > 0
            ? Math.round((a.questions_completed / a.num_questions) * 100)
            : 0;

          return (
            <div key={a.id} className="assignment-item">
              <div className="assignment-item-header">
                <span className="assignment-item-title">{a.title}</span>
                {a.due_date && (
                  <span className="assignment-due">
                    Due: {new Date(a.due_date).toLocaleDateString()}
                  </span>
                )}
              </div>
              <div className="assignment-item-info">
                Unit {a.target_unit}
                {a.target_lesson && `, Lesson ${a.target_lesson}`}
                {' \u2022 '}{a.questions_completed}/{a.num_questions} questions
              </div>
              {a.status === 'in_progress' && (
                <div className="assignment-progress-bar">
                  <div className="assignment-progress-fill" style={{ width: `${pct}%` }} />
                </div>
              )}
              <Link
                to={`/practice/${a.target_unit}/${a.target_lesson || 1}?mode=assignment&assignment_id=${a.id}`}
                className="assignment-start-btn"
                onClick={() => handleStart(a)}
              >
                {a.status === 'in_progress' ? 'Continue' : 'Start'}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};
